import { useRef, useState, useCallback } from 'react';

export const useScrollEdges = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [scrollAtTop, setScrollAtTop] = useState(true);
  const [scrollAtBottom, setScrollAtBottom] = useState(true);

  const updateScrollPosition = useCallback(() => {
    if (!ref.current) {
      return;
    }
    const scrollVal = ref.current.scrollTop;
    if (scrollVal <= 1 && !scrollAtTop) {
      setScrollAtTop(true);
    } else if (scrollVal > 1 && scrollAtTop) {
      setScrollAtTop(false);
    }
    const maxScroll = ref.current.scrollHeight - ref.current.offsetHeight;

    if (scrollVal >= maxScroll && !scrollAtBottom) {
      setScrollAtBottom(true);
    } else if (scrollVal < maxScroll && scrollAtBottom) {
      setScrollAtBottom(false);
    }
  }, [scrollAtBottom, scrollAtTop, setScrollAtBottom, setScrollAtTop, ref]);

  return {
    scrollAtTop,
    scrollAtBottom,
    ref,
    updateScrollPosition,
  };
};
